export default {
  methods: {
    updateFormValue(event) {
      this.$emit("updateField", event);
    },
    fieldHasErrors(section, fieldName) {
      return this.errors[section].indexOf(fieldName) !== -1;
    },
  },
  computed: {
    tabActiveClass() {
      var classActive = this.activeTab ? "show active" : "";
      return `tab-pane fade ${classActive}`;
    },
  },
};
